import type { InjectionKey } from 'vue'

export type DocumentPreviewHandler = (
  documentId: number,
  documentProperties?: Record<string, unknown>
) => void

export const documentPreviewHandlerKey: InjectionKey<DocumentPreviewHandler> =
  Symbol('documentPreviewHandler')
